"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  a11yProps: true,
  clickProps: true,
  copyPropTypes: true,
  componentPropType: true,
  hrefAttrsProp: true,
  inputSupportsProps: true,
  linkProps: true,
  pressProps: true,
  paddingProp: true,
  rectProp: true,
  responsiveProps: true,
  spacingProps: true,
  selectSystemProps: true,
  textInputProps: true,
  textProps: true,
  variantProp: true,
  viewProps: true,
  contentfulProps: true
};
Object.defineProperty(exports, "a11yProps", {
  enumerable: true,
  get: function () {
    return _a11yProps.default;
  }
});
Object.defineProperty(exports, "clickProps", {
  enumerable: true,
  get: function () {
    return _clickProps.default;
  }
});
Object.defineProperty(exports, "componentPropType", {
  enumerable: true,
  get: function () {
    return _componentPropType.default;
  }
});
Object.defineProperty(exports, "contentfulProps", {
  enumerable: true,
  get: function () {
    return _contentfulProps.default;
  }
});
Object.defineProperty(exports, "copyPropTypes", {
  enumerable: true,
  get: function () {
    return _copyPropTypes.default;
  }
});
Object.defineProperty(exports, "hrefAttrsProp", {
  enumerable: true,
  get: function () {
    return _hrefAttrsProp.default;
  }
});
Object.defineProperty(exports, "inputSupportsProps", {
  enumerable: true,
  get: function () {
    return _inputSupportsProps.default;
  }
});
Object.defineProperty(exports, "linkProps", {
  enumerable: true,
  get: function () {
    return _linkProps.default;
  }
});
Object.defineProperty(exports, "paddingProp", {
  enumerable: true,
  get: function () {
    return _paddingProp.default;
  }
});
Object.defineProperty(exports, "pressProps", {
  enumerable: true,
  get: function () {
    return _pressProps.default;
  }
});
Object.defineProperty(exports, "rectProp", {
  enumerable: true,
  get: function () {
    return _rectProp.default;
  }
});
Object.defineProperty(exports, "responsiveProps", {
  enumerable: true,
  get: function () {
    return _responsiveProps.default;
  }
});
Object.defineProperty(exports, "selectSystemProps", {
  enumerable: true,
  get: function () {
    return _selectSystemProps.default;
  }
});
Object.defineProperty(exports, "spacingProps", {
  enumerable: true,
  get: function () {
    return _spacingProps.default;
  }
});
Object.defineProperty(exports, "textInputProps", {
  enumerable: true,
  get: function () {
    return _textInputProps.default;
  }
});
Object.defineProperty(exports, "textProps", {
  enumerable: true,
  get: function () {
    return _textProps.default;
  }
});
Object.defineProperty(exports, "variantProp", {
  enumerable: true,
  get: function () {
    return _variantProp.default;
  }
});
Object.defineProperty(exports, "viewProps", {
  enumerable: true,
  get: function () {
    return _viewProps.default;
  }
});
var _tokens = require("./tokens");
Object.keys(_tokens).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tokens[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tokens[key];
    }
  });
});
var _handlerProps = require("./handlerProps");
Object.keys(_handlerProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _handlerProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _handlerProps[key];
    }
  });
});
var _a11yProps = _interopRequireDefault(require("./a11yProps"));
var _clickProps = _interopRequireDefault(require("./clickProps"));
var _copyPropTypes = _interopRequireDefault(require("./copyPropTypes"));
var _componentPropType = _interopRequireDefault(require("./componentPropType"));
var _hrefAttrsProp = _interopRequireDefault(require("./hrefAttrsProp"));
var _inputSupportsProps = _interopRequireDefault(require("./inputSupportsProps"));
var _linkProps = _interopRequireDefault(require("./linkProps"));
var _pressProps = _interopRequireDefault(require("./pressProps"));
var _paddingProp = _interopRequireDefault(require("./paddingProp"));
var _rectProp = _interopRequireDefault(require("./rectProp"));
var _responsiveProps = _interopRequireDefault(require("./responsiveProps"));
var _spacingProps = _interopRequireDefault(require("./spacingProps"));
var _selectSystemProps = _interopRequireDefault(require("./selectSystemProps"));
var _textInputProps = _interopRequireDefault(require("./textInputProps"));
var _textProps = _interopRequireDefault(require("./textProps"));
var _variantProp = _interopRequireDefault(require("./variantProp"));
var _viewProps = _interopRequireDefault(require("./viewProps"));
var _contentfulProps = _interopRequireDefault(require("./contentfulProps"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }